function ChangeCompany() {
    return (
        <div>
            <h2>Change Company</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default ChangeCompany;